export const generalDetails = ['associationName', 'id', 'contact', 'phone', 'email'];
export const documents = ['section46Expiry', 'signedContract', 'acceptedProcedure'];
export const bankDetails = ['bankAccountHolder', 'bankName', 'bankBranchNumber', 'bankAccountNumber'];
export const managerDetails = ['managerFullName', 'managerEmail', 'managerPhone'];
export const additionalDetails = ['volunteerNumber', 'sumDonated'];
export const purchaseLink = ['purchaseLink'];
